import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

interface NavItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatListModule, RouterModule],
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss']
})
export class AppSidebarComponent {
  @Input() activeRoute = '';
  navItems: NavItem[] = [
    { label: 'Dashboard', icon: 'home', route: '/dashboard' },
    { label: 'Clients', icon: 'groups', route: '/clients' },
    { label: 'Appointments', icon: 'event', route: '/appointments' },
    { label: 'Treatments', icon: 'healing', route: '/consultations' },
    { label: 'Nowa konsultacja', icon: 'add_circle', route: '/consultations/new-consultation' },
    { label: 'Projektant formularza', icon: 'design_services', route: '/consultations/builder' },
    { label: 'Reports', icon: 'assessment', route: '/reports' },
    { label: 'Admin', icon: 'settings', route: '/admin'}
  ];
} 